import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Response type
export interface UnsetFavoriteChatSessionResponse {
  success: boolean;
  message: string;
  is_favorite: boolean;
}

// Axios DELETE request
export function unsetChatSessionFavorite(
  chat_session_uid: string,
): Promise<AxiosResponse<UnsetFavoriteChatSessionResponse>> {
  return axios.delete<UnsetFavoriteChatSessionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/session/${chat_session_uid}/favorite`,
  );
}
